import React, { useState, useEffect } from 'react';

const RenderCLNScomponent = () => {
  const [text, setText] = useState('');
  const [images, setImages] = useState(Array(6).fill(null));

  // Fetch initial data from API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://admindashboard.clns.in/api/dash/teamclns/');
        const result = await response.json();
        
        if (result.status && result.data) {
          setText(result.data.description);
          setImages([
            result.data.image1,
            result.data.image2,
            result.data.image3,
            result.data.image4,
            result.data.image5,
            result.data.image6,
          ]);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  // Handle text change
  const handleTextChange = (e) => {
    setText(e.target.value);
  };

  // Handle file upload
  const handleFileChange = (index, file) => {
    const newImages = [...images];
    newImages[index] = file;
    setImages(newImages);
  };

  // Reset state
  const handleReset = () => {
    setText('');
    setImages(Array(6).fill(null));
  };

  // Submit data to API
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const formData = new FormData();
    formData.append('description', text);
    images.forEach((image, index) => {
      if (image) {
        formData.append(`image${index + 1}`, image);
      }
    });

    try {
      const response = await fetch('https://admindashboard.clns.in/api/dash/teamclns/', {
        method: 'POST',
        body: formData,
      });
      const result = await response.json();
      
      if (result.status) {
        alert('Changes saved successfully!');
        // Optionally reset the form after submission
        handleReset();
      } else {
        alert('Failed to save changes. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting data:', error);
      alert('An error occurred while submitting data.');
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <form onSubmit={handleSubmit}>
        <div>
          <label
            style={{
              display: "block",
              marginBottom: "10px",
              fontWeight: "bold",
            }}
          >
            Write About Team CSLN
          </label>
          <textarea
            style={{
              width: "100%",
              minHeight: "100px",
              padding: "10px",
              marginBottom: "20px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
            value={text}
            onChange={handleTextChange}
          />
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: "20px",
            marginBottom: "20px",
          }}
        >
          {images.map((image, index) => (
            <div key={index} style={{ textAlign: "center" }}>
              <p style={{ marginBottom: "10px" }}>Add image in btw</p>
              {image instanceof File ? (
                <img
                  src={URL.createObjectURL(image)}
                  alt={`team member ${index + 1}`}
                  style={{
                    width: "100%",
                    height: "auto",
                    marginBottom: "10px",
                    borderRadius: "4px",
                  }}
                />
              ) : (
                <img
                  src={image || "/api/placeholder/200/200"}
                  alt="placeholder"
                  style={{
                    width: "100%",
                    height: "auto",
                    marginBottom: "10px",
                    borderRadius: "4px",
                  }}
                />
              )}
              <input
                type="file"
                accept="image/*"
                onChange={(e) => handleFileChange(index, e.target.files[0])}
                style={{
                  width: "100%",
                  padding: "8px",
                  backgroundColor: "#fff",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              />
            </div>
          ))}
        </div>

        <button
          type="submit"
          style={{
            padding: "10px 20px",
            backgroundColor: "#007bff",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            marginRight: "10px",
          }}
        >
          Submit
        </button>
        <button
          type="button"
          onClick={handleReset}
          style={{
            padding: "10px 20px",
            backgroundColor: "#f44336",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Reset
        </button>
      </form>
    </div>
  );
};

export default RenderCLNScomponent;
